<div
  class="toolbar my-2"
  *ngIf="EnablePageSize"
>

  <select
    name="pageSizeSelect"
    [(ngModel)]="pageSize"
    (ngModelChange)="onPageSizeChanged($event)"
    aria-label="Records per page"
  >

    <option [ngValue]="10">
      10
    </option>

    <option [ngValue]="25">
      25
    </option>

    <option [ngValue]="50">
      50
    </option>

    <option [ngValue]="100">
      100
    </option>

  </select>


  <span>
    Showing {{ start }} to {{ end }}
    |
    Total Records : {{ totalRecords }}
  </span>

</div>



<div
  class="mt-1"
  *ngIf="EnableNavigation"
>

  <nav
    class="toolbar d-flex justify-content-between"
    style="margin-top: 30px;"
    aria-label="Pagination"
  >

    <div>

      Page
      {{ totalPages === 0 ? 0 : currentPage }}
      of
      {{ totalPages }}

      <span>
        |
        Showing {{ start }} to {{ end }}
        |
        Total Records : {{ totalRecords }}
      </span>

    </div>


    <div
      style="
        display: flex;
        gap: 10px;
        align-items: center;
        justify-content: end;
        flex-wrap: wrap;
        margin-right: 50px;
      "
    >

      <!-- Previous -->

      <button
        type="button"
        (click)="goToPreviousPage()"
        [disabled]="currentPage <= 1 || totalPages === 0"
        aria-label="Previous page"
        style="
          border: none;
          background: transparent;
          color: #3d0043;
          cursor: pointer;
        "
      >
        &lt;
      </button>



      <!-- When total pages <= 7 -->

      <ng-container *ngIf="totalPages <= 7">

        <button
          type="button"
          *ngFor="let page of getPagesToShow()"
          (click)="goToNumberPage(page)"
          [attr.aria-label]="'Go to page ' + page"
          [attr.aria-current]="
            currentPage === page
              ? 'page'
              : null
          "
          [ngStyle]="{
            'padding': '6px 12px',
            'border-radius': '8px',
            'cursor': 'pointer',
            'border': 'none',
            'background-color':
              currentPage === page
                ? '#3d0043'
                : '#f0eaff',
            'color':
              currentPage === page
                ? 'white'
                : '#3d0043'
          }"
        >
          {{ page }}
        </button>

      </ng-container>



      <!-- When total pages > 7 -->

      <ng-container *ngIf="totalPages > 7">

        <!-- First Page -->

        <button
          type="button"
          (click)="goToNumberPage(1)"
          aria-label="Go to page 1"
          [attr.aria-current]="
            currentPage === 1
              ? 'page'
              : null
          "
          [ngStyle]="{
            'padding': '6px 12px',
            'border-radius': '8px',
            'cursor': 'pointer',
            'border': 'none',
            'background-color':
              currentPage === 1
                ? '#3d0043'
                : '#f0eaff',
            'color':
              currentPage === 1
                ? 'white'
                : '#3d0043'
          }"
        >
          1
        </button>



        <!-- Left Ellipsis -->

        <span
          *ngIf="currentPage > 4"
          style="
            padding: 6px 12px;
            color: #555;
          "
          aria-hidden="true"
        >
          ...
        </span>



        <!-- Middle Pages -->

        <ng-container
          *ngFor="let page of getPagesToShow()"
        >

          <button
            type="button"
            *ngIf="
              page !== 1 &&
              page !== totalPages
            "
            (click)="goToNumberPage(page)"
            [attr.aria-label]="
              'Go to page ' + page
            "
            [attr.aria-current]="
              currentPage === page
                ? 'page'
                : null
            "
            [ngStyle]="{
              'padding': '6px 12px',
              'border-radius': '8px',
              'cursor': 'pointer',
              'border': 'none',
              'background-color':
                currentPage === page
                  ? '#3d0043'
                  : '#f0eaff',
              'color':
                currentPage === page
                  ? 'white'
                  : '#3d0043'
            }"
          >
            {{ page }}
          </button>

        </ng-container>



        <!-- Right Ellipsis -->

        <span
          *ngIf="
            currentPage <
            totalPages - 3
          "
          style="
            padding: 6px 12px;
            color: #555;
          "
          aria-hidden="true"
        >
          ...
        </span>



        <!-- Last Page -->

        <button
          type="button"
          (click)="
            goToNumberPage(totalPages)
          "
          [attr.aria-label]="
            'Go to page ' + totalPages
          "
          [attr.aria-current]="
            currentPage === totalPages
              ? 'page'
              : null
          "
          [ngStyle]="{
            'padding': '6px 12px',
            'border-radius': '8px',
            'cursor': 'pointer',
            'border': 'none',
            'background-color':
              currentPage === totalPages
                ? '#3d0043'
                : '#f0eaff',
            'color':
              currentPage === totalPages
                ? 'white'
                : '#3d0043'
          }"
        >
          {{ totalPages }}
        </button>

      </ng-container>



      <!-- Next -->

      <button
        type="button"
        (click)="goToNextPage()"
        [disabled]="
          totalPages === 0 ||
          currentPage >= totalPages
        "
        aria-label="Next page"
        style="
          border: none;
          background: transparent;
          color: #3d0043;
          cursor: pointer;
        "
      >
        &gt;
      </button>

    </div>

  </nav>

</div>